// Game arrays
export const game1 = [
  { d: "MONDAY SPECIAL", day: "Monday", closingTime: "19:55" },
  { d: "LUCKY TUESDAY", day: "Tuesday", closingTime: "19:55" },
  { d: "MIDWEEK", day: "Wednesday", closingTime: "19:55" },
  { d: "FORTUNE THURSDAY", day: "Thursday", closingTime: "19:55" },
  { d: "FRIDAY BONANZA", day: "Friday", closingTime: "19:55" },
  { d: "NATIONAL WEEKLY", day: "Saturday", closingTime: "19:55" },
  { d: "SUNDAY ASEDA", day: "Sunday", closingTime: "19:55" },
];

export const game2 = [
  { d: "NLA VAG MONDAY", day: "Monday", closingTime: "09:55" },
  { d: "NLA NOON RUSH MONDAY", day: "Monday", closingTime: "12:50" },
  { d: "HUNTEX MONDAY", day: "Monday", closingTime: "21:50" },
  { d: "NLA VAG TUESDAY", day: "Tuesday", closingTime: "09:55" },
  { d: "NLA NOON RUSH TUESDAY", day: "Tuesday", closingTime: "12:50" },
  { d: "HUNTEX AKOMA TUESDAY", day: "Tuesday", closingTime: "21:00" },
  { d: "NLA VAG WEDNESDAY", day: "Wednesday", closingTime: "09:55" },
  { d: "NLA NOON RUSH WEDNESDAY", day: "Wednesday", closingTime: "12:50" },
  { d: "HUNTEX WEDNESDAY", day: "Wednesday", closingTime: "21:50" },
  { d: "NLA VAG THURSDAY", day: "Thursday", closingTime: "09:55" },
  { d: "NLA NOON RUSH THURSDAY", day: "Thursday", closingTime: "12:50" },
  { d: "HUNTEX THURSDAY", day: "Thursday", closingTime: "21:50" },
  { d: "NLA VAG FRIDAY", day: "Friday", closingTime: "09:55" },
  { d: "NLA NOON RUSH FRIDAY", day: "Friday", closingTime: "12:50" },
  { d: "HUNTEX FRIDAY", day: "Friday", closingTime: "21:50" },
  { d: "NLA VAG SATURDAY", day: "Saturday", closingTime: "09:55" },
  { d: "NLA NOON RUSH SATURDAY", day: "Saturday", closingTime: "12:50" },
  { d: "HUNTEX SATURDAY", day: "Saturday", closingTime: "21:50" },
  { d: "HUNTEX SUNDAY", day: "Sunday", closingTime: "21:50" },
];

// Timer logic
export function getTimeRemaining(games) {
  const now = new Date();

  const remainingTimes = games.map((gameItem) => {
    const gameDayIndex = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ].indexOf(gameItem.day);
    const currentDayIndex = now.getDay();

    let nextGameDayIndex = (gameDayIndex - currentDayIndex + 7) % 7;

    // Calculate next game date
    const nextGameDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + nextGameDayIndex
    );

    // Set closing time
    const [hours, minutes] = gameItem.closingTime.split(":").map(Number);
    nextGameDate.setHours(hours, minutes, 0, 0);

    // If the game is today but already closed, move to next week
    if (
      nextGameDayIndex === 0 &&
      now.getTime() > nextGameDate.getTime()
    ) {
      nextGameDate.setDate(nextGameDate.getDate() + 7);
    }

    // Calculate remaining time
    const total = nextGameDate - now;
    const seconds = Math.floor((total / 1000) % 60);
    const minutesLeft = Math.floor((total / 1000 / 60) % 60);
    const hoursLeft = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      ...gameItem,
      nextGameStartTime: nextGameDate,
      remainingTime: {
        total,
        days,
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds,
      },
    };
  });

  // Sort by soonest nextGameStartTime
  const sortedGames = remainingTimes.sort((a, b) => a.nextGameStartTime - b.nextGameStartTime);

  return sortedGames;
}